import axios from '@/request';
import qs from 'qs';

export default {
    async list(params: any) {
        return axios.get('privatetel/list', { params });
    },
    async phones(params: any) {
        return axios.get('privatetel/phones', { params })
    },
    async phoneadd(params: any) {
        return axios.post('privatetel/phone-add', qs.stringify(params))
    },
    async phoneedit(params: any) {
        return axios.post('privatetel/phone-edit', qs.stringify(params))
    },
    async phonedetail(params: any) {
        return axios.get('privatetel/phone-detail', { params })
    },
    async phonedelete(params: any) {
        return axios.post('privatetel/phone-delete', qs.stringify(params))
    }
}
